import { render } from "./DisciplineMultiLovComponent.vue?vue&type=template&id=68ecf540"
import script from "./DisciplineMultiLovComponent.vue?vue&type=script&lang=js"
export * from "./DisciplineMultiLovComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__